import NotFound from 'modules/core/components/NotFound'

const NotFoundPage = () => {
  return <NotFound />
}

export default NotFoundPage
